import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UsersService } from './users.service';

@Injectable({ providedIn: 'root' })
export class ZohoCustomerLinksService {
  constructor(
    private http: HttpClient,
    private users: UsersService
  ) {}

  remove(userId: number, contactId: string) {
    const url = this.users.utils.buildUrl(`admin/usr/users/${userId}/zoho-settings/previous-customers/${encodeURIComponent(contactId)}`);
    return this.http.delete<void>(url, this.users.utils.getHttpHeaderOptions(this.users.headers));
  }
}
